import Biblioteca from '@/components/Repositorio/Biblioteca.js'

export default {
  async verificarDadosConsumidorFinal(axios, parametros) {
    parametros.operacao = 'verificarDadosConsumidorFinal';

    let retorno = {};
    await axios.santriPOST('/rest/orcamento', parametros, 25, false)
    .then(response => {
      retorno = Biblioteca.retornoRequisicao('N', undefined, response.data)
    })
    .catch(erro => {
      retorno = Biblioteca.retornoRequisicao('S', erro, undefined)
    })
  
    return retorno;
  }
}


// WEBPACK FOOTER //
// ./src/components/Rest/ROrcamento/ROrcamentoVerificarDadosConsumidorFinal.js